/* global jQuery, bonusMaterialsData */
/* eslint-disable indent */

jQuery(document).ready(function ($) {
  // Constants
  const MATERIALS_LIMIT = 5;
  const isWebinarPage = window.location.pathname.includes('/webinar/');

  // State
  let showAllMaterials = false;

  // Elements
  const $bonusMaterialsSection = $('#sectionBonusMaterials');
  const $searchInput = $('#materials-search');
  const $listMaterialsBtn = $('#list-materials-btn');
  const $downloadAllBtn = $('#download-all-btn');
  const $materialsTableContainer = $('#materials-table-container');
  const $materialsTableBody = $('#materials-table-body');
  const $infoTooltip = $('.info-tooltip');
  const $materialsCounter = $('#materials-counter');
  const $totalCount = $('.total-count');
  const $fadeOverlay = $('#materials-fade-overlay');
  let hasMaterials = false;
  let hasSearchedOnce = false;

  // Initialize
  function init() {
    hasMaterials = bonusMaterialsData?.materials?.length;

    if (!hasMaterials) {
      $bonusMaterialsSection.addClass('hidden');
      return;
    }

    bindEvents();

    if (hasMaterials) {
      populateMaterialsTable();
    }
  }

  // Bind all event handlers
  function bindEvents() {
    $listMaterialsBtn.off('click').on('click', toggleShowAll);
    $searchInput.off('input').on('input', handleSearch);
    $downloadAllBtn.on('mouseenter', () => $infoTooltip.removeClass('hidden'));
    $downloadAllBtn.on('mouseleave', () => $infoTooltip.addClass('hidden'));
    $downloadAllBtn.off('click').on('click', handleDownloadAll);
  }

  // Add or remove the overlay depending on materials count and state
function updateFadeOverlay(materialCount) {
  if (!showAllMaterials && materialCount > 5) {
    $fadeOverlay.removeClass('hidden');
  } else {
    $fadeOverlay.addClass('hidden');
  }
}

  function toggleShowAll() {
    showAllMaterials = !showAllMaterials;
    $listMaterialsBtn.addClass('hidden');

    if (hasMaterials) {
      populateMaterialsTable();
    }
  }

  // Search filter
function handleSearch() {
  if (!hasMaterials) {
    return;
  }

  const term = $(this).val().toLowerCase().trim();
  const $rows = $materialsTableBody.find('tr');

  // Case 1: User clears input or types <2 chars
  if (term.length < 2) {
    if (hasSearchedOnce) {
      // Only reset if a search was previously done
      showAllMaterials = true;
      populateMaterialsTable(); // show all, unfiltered
      updateMaterialsCounter($rows.length, $rows.length);
    }
    return; // Don't apply filters yet
  }

  // Case 2: Valid search (≥2 chars)
  hasSearchedOnce = true;
  showAllMaterials = true;
  populateMaterialsTable(); // full list (for filtering)

  let visibleCount = 0;

  $materialsTableBody.find('tr').each(function () {
    const $row = $(this);
    const matches = $row.text().toLowerCase().includes(term);
    $row.css('display', matches ? '' : 'none');
    if (matches) visibleCount++;
  });

  updateMaterialsCounter(visibleCount, $rows.length);
}

  // Download all materials
  async function handleDownloadAll(event) {
    event.preventDefault();
    event.stopPropagation();

    try {
      const response = await fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Object.assign(
            {
              action: 'download_all_materials',
              nonce: bonusMaterialsData.nonce,
            },
            bonusMaterialsData.context
              ? {
                  'context[id]': bonusMaterialsData.context.id,
                  'context[type]': bonusMaterialsData.context.type,
                  'context[template]': bonusMaterialsData.context.template,
                }
              : {}
          )
        ),
      });

      if (!response.ok) throw new Error(await response.text() || 'Network error');

      const contentDisposition = response.headers.get('Content-Disposition');
      const blob = await response.blob();
      if (blob.size === 0) throw new Error('Stažený soubor je prázdný');

      const filename = extractFilename(contentDisposition) || 'materialy.zip';
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
      a.remove();

    } catch (error) {
      let msg = 'Nastala chyba při stahování souborů';
      try {
        const parsed = JSON.parse(error.message);
        if (parsed?.data) msg = parsed.data;
      } catch {
        msg += `: ${error.message}`;
      }
      alert(msg);
    }
  }

  function extractFilename(header) {
    if (!header) return null;
    const match = /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?/i.exec(header);
    return match?.[1] ? decodeURIComponent(match[1]) : null;
  }

  // Update counter display
  function updateMaterialsCounter(visibleCount, totalCount) {
    const shown = showAllMaterials ? visibleCount : Math.min(visibleCount, MATERIALS_LIMIT);
    $materialsCounter.find('span:first').text(shown);
    $totalCount.text(totalCount);
  }

  // Render materials table
  function populateMaterialsTable() {
    
    if (!$materialsTableBody.length) return;

    let materials = bonusMaterialsData.materials;
    
    $materialsTableBody.empty();

    const sorted = materials.slice().sort((a, b) => {
      const aIsCourse = a.lesson === 'Bonusové materiály';
      const bIsCourse = b.lesson === 'Bonusové materiály';
      return aIsCourse === bIsCourse ? 0 : aIsCourse ? -1 : 1;
    });

    const visibleMaterials = showAllMaterials ? sorted : sorted.slice(0, MATERIALS_LIMIT);

    visibleMaterials.forEach((material) => {
      const $row = $('<tr>').addClass('border-b hover:bg-gray-50 grid grid-cols-2 md:table-row');
      const tagColor = getTypeColor(material.type);
      const fileTag = `
        <span class="inline-flex justify-center items-center gap-[0.625rem] p-[0.625rem] rounded-[0.625rem]" 
              style="background-color: ${tagColor}">
          <span class="tag-text">${material.type}</span>
        </span>`;

      const downloadBtn = `
        <a href="${material.url}" 
           target="_blank"
           class="inline-flex items-center justify-center px-3 py-1 text-sm font-medium text-white bg-[#e37222] rounded-[0.625rem] hover:bg-[#ff7800] transition-colors">
           Stáhnout
        </a>`;

      if (!isWebinarPage) {
        $row.html(`
          <td class="px-2 md:px-6 py-4 break-words text-sm text-gray-900">${material.lesson}</td>
          <td class="px-2 md:px-6 py-4 break-words text-sm text-gray-900">${material.name}</td>
          <td class="px-2 md:px-6 pt-0 pb-2 md:py-4 text-sm">${fileTag}</td>
          <td class="px-2 md:px-6 pt-0 pb-2 md:py-4 md:text-right text-sm font-medium">${downloadBtn}</td>
        `);
      } else {
        $row.html(`
          <td class="px-2 md:px-6 py-4 break-words text-sm text-gray-900">${material.name}</td>
          <td class="px-2 md:px-6 py-4 text-sm">${fileTag}</td>
          <td class="px-2 md:px-6 pt-0 pb-2 md:py-4 text-sm font-medium">${downloadBtn}</td>
        `);
      }

      $materialsTableBody.append($row);
    });

    if (sorted.length < 5) {
      $listMaterialsBtn.addClass('hidden');
    }

    updateFadeOverlay(sorted.length);
    updateMaterialsCounter(sorted.length, sorted.length);
  }

  // File type color mapping
  function getTypeColor(type) {
    const map = {
      PDF: '#f04770',
      DOC: '#60a5fa',
      DOCX: '#60a5fa',
      XLS: '#60a5fa',
      XLSX: '#60a5fa',
      JPG: '#34d399',
      JPEG: '#34d399',
      PNG: '#34d399',
      WEBP: '#34d399',
      ZIP: '#fcd34d',
    };
    return map[type.toUpperCase()] || '#9333ea';
  }

  // Run setup
  init();
});
